<template>
  <vxe-modal
    v-model="modalPurchase"
    :title="$t('purchaseDataList')"
    width="80%"
    height="80%"
    show-zoom
    resize
  >
    <template #default>
      <el-checkbox v-model="isHeaderPo">
        <b>Get Header PO</b>
      </el-checkbox>

      <TableFull
        ref="tableWo"
        :tableConfig="tableConfigPurchase"
        @changeFilter="changeFilter"
        @sendData="selectModalPurchase"
      />

      <vxe-form title-align="right" title-width="60">
        <vxe-form-item align="center" span="24">
          <template #default>
            <vxe-button type="reset" @click="modalPurchase = false"
              >Close</vxe-button
            >
          </template>
        </vxe-form-item>
      </vxe-form>
    </template>
  </vxe-modal>
</template>

<script>
import TableFull from "../../components/general/TableFull.vue";
export default {
  components: { TableFull },
  data() {
    return {
      modalPurchase: false,
      tableConfigPurchase: {
        bodyOverflow: false,
        headerOverflow: false,
        checkbox: false,
        select: true,

        selectButton: this.$t("check"),

        tableHeight: 450,
        rowHeight: 35,
        tableData: [],
        size: "mini",
        dataFooter: ["qty", "qtyUse", "qtyBalanceExim"],
        tableName: "tableOurchase",
        column: [
          {
            field: "noPo",
            key: "noPo",
            title: this.$t("poNumber").toUpperCase(),
            width: 150,
            align: "left",
          },
          {
            field: "noReg",
            key: "noReg",
            title: this.$t("noRegi").toUpperCase(),
            width: 150,
            align: "left",
          },
          {
            field: "tanggal",
            key: "tanggal",
            title: this.$t("tanggal").toUpperCase(),
            width: 100,
            align: "left",
            format: "date",
          },
          {
            field: "kodeSupplier",
            key: "kodeSupplier",
            title: this.$t("kodeSupplier").toUpperCase(),
            width: 100,
            align: "left",
          },
          {
            field: "namaSupplier",
            key: "namaSupplier",
            title: this.$t("nameSupplier").toUpperCase(),
            width: 150,
            align: "left",
          },

          {
            field: "kodeBarang",
            key: "kodeBarang",
            title: this.$t("code").toUpperCase(),
            width: 120,
            align: "left",
          },
          {
            field: "namaBarang",
            key: "namaBarang",
            title: this.$t("deskripsi").toUpperCase(),
            width: 150,
            align: "left",
          },
          {
            field: "satuan",
            key: "satuan",
            title: this.$t("satuan").toUpperCase(),
            width: 80,
            align: "center",
          },
          {
            field: "kategori",
            key: "kategori",
            title: this.$t("kategori").toUpperCase(),
            width: 100,
            align: "center",
          },
          {
            field: "style",
            key: "style",
            title: this.$store.state.styleName,
            show: this.$store.state.availableStyle,

            width: 120,
            align: "center",
          },
          {
            field: "color",
            key: "color",
            title: this.$store.state.colorName,
            show: this.$store.state.availableColor,

            width: 120,
            align: "center",
          },
          {
            field: "size",
            key: "size",
            title: this.$store.state.sizeName,
            show: this.$store.state.availableSize,

            width: 120,
            align: "center",
          },
          {
            field: "spec",
            key: "spec",
            title: this.$store.state.specName,
            show: this.$store.state.availableSpec,

            width: 120,
            align: "center",
          },
          {
            field: "currency",
            key: "currency",
            title: this.$t("currency").toUpperCase(),
            width: 120,
            align: "center",
          },
          {
            field: "qty",
            key: "qty",
            title: this.$t("qty").toUpperCase(),
            width: 100,
            align: "right",
            format: "price",
          },
          {
            field: "qtyUse",
            key: "qtyUse",
            title: this.$t("qtyArrived").toUpperCase(),
            width: 100,
            align: "right",
            format: "price",
          },
          {
            field: "qtyBalanceExim",
            key: "qtyBalanceExim",
            title: this.$t("qtyBalanceArrived").toUpperCase(),
            width: 100,
            align: "right",
            format: "price",
          },
        ],
        dataFooter: ["qtyBalanceExim", "qtyUse", "qty"],
      },
      isHeaderPo: false,
    };
  },
  mounted() {
    this.getPo();
  },
  methods: {
    modalToggle() {
      this.modalPurchase = !this.modalPurchase;
    },
    async getHeaderPo(data) {
      this.loadingWait();
      let get = await this.$api.get(
        "api/v1/purchasing/podetail/spesific/searchpo",
        {
          params: { noPo: data.noPo },
        }
      );
      let datas = get.data.content.listDetail;
      let head = get.data.content;
      let baca = [];
      for (let elm of datas) {
        let cek = baca.find((f) => f.idPo == elm.id);
        if (cek) {
          this.notifValidasi("Data sudah ada", true);
          continue;
        }
        let req = { ...elm };
        req["idPo"] = elm.id;
        req["qty"] = elm.qtyBalanceExim;
        req["noRegPo"] = elm.noReg;
        req["priceInvoice"] = elm.price;
        req["amountInvoice"] = elm.price * req.qty;
        delete req["_X_ROW_KEY"];
        delete req["id"];
        delete req["noReg"];
        baca.push(req);
      }

      this.loadingStop();
      this.$emit("selectedPurchaseHeader", baca);
      this.notifikasiCustom(
        "success",
        "Berhasil",
        "Mimilih data Purchase Order"
      );
    },

    async getPo(filterList) {
      if (!filterList) filterList = [];
      let dataSearch = {};
      for (let elm of filterList) {
        dataSearch[elm.field] = elm.datas[0];
      }

      dataSearch.companyCode = this.$store.state.companyCode;
      let url = "purchasing/notequalsmasuk";
      if (this.isHeaderPo) {
        url = "purchasing/findheader";
      }

      let get = await this.$api.get(this.$serviceApi + url, {
        params: dataSearch,
      });

      this.tableConfigPurchase.tableData = get.data.content;
      // const response = await this.$api.get(`/api/v1/purchasing/notequals`);
      // this.dataPo = [];

      // let tmp0 = response.data.content.sort(this.compareValues("id", "desc"));
      // tmp0.forEach((el0) => {
      //   this.dataPo.push(el0);
      // });
    },
    selectModalPurchase(data) {
      if (this.isHeaderPo == true) {
        this.getHeaderPo(data);
        return;
      }

      let req = { ...data };
      req["idPo"] = data.id;
      req["qty"] = data.qtyBalanceExim;
      req["priceInvoice"] = data.price;
      req["amountInvoice"] = data.price * req.qty;
      req["noRegPo"] = data.noReg;

      delete req["_X_ROW_KEY"];
      delete req["id"];
      delete req["noReg"];
      this.notifikasiCustom(
        "success",
        "Berhasil",
        "Mimilih data Purchase Order"
      );
      this.$emit("selectedPurchase", req);
    },

    async changeFilter({
      column,
      property,
      values,
      datas,
      filterList,
      $event,
    }) {
      if (filterList.length == 0) {
        this.getPo();
        return;
      }

      this.getPo(filterList);
    },
  },
};
</script>
